import {Button, FontIcon} from "@/app/_components";
import styles from './list.module.css';
import {DriveUtil} from "@/Master/DriveUtil";
import Load from "@/app/_components/Load/Load";
import React from "react";
import {RedeemRecordState} from "@/Core/Redeem/redeemEnum";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";
import TrackRedeem from "@/Core/Track/TrackRedeem";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemRecordSuccessfulDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordSuccessfulDialogFC";
import {RedeemRecordReviewDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordReviewDialogFC";
import {RedeemRecordFailDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordFailDialogFC";
import RedeemUtil from "@/Core/Redeem/RedeemUtil";
import {RedeemChannelType} from "@/Core/Redeem/RedeemChannelType";
import BigTips from "@/Master/BigTips";
import {RedeemKYCDialogFC} from "@/app/(redeem)/UI/RedeemKYCDialogFC";
import {RedeemSubmittedDialogFC} from "@/app/(redeem)/UI/RedeemSubmittedDialogFC";

type RedeemRecordItemProps = {
    redeemRecordInfo: RedeemRecordInfo,
    onUpdateData?: () => void
}

const status = {
    reCheck: '#FFA800',
    success: '#29D181',
    fail: '#FE414E',
}

const btnStyles = {
    color: '#fff',
    width: '1.7rem',
    height: '0.6rem',
}

const RedeemRecordItem: React.FC<RedeemRecordItemProps> = (props) => {
    const {redeemRecordInfo,onUpdateData} = props;

    const getYuanImgName = (channelType:number) => {
        let typeName = "";
        if (channelType > 0){
            typeName = RedeemUtil.getChannelTypeName(channelType);
        }else{
            typeName = RedeemUtil.getChannelTypeName(RedeemChannelType.Paypal);
        }
        return `/img/redeem/img_y_${typeName}.webp`;
    }

    const onCLickSuccessful = () => {
        TrackRedeem.redeem_success_show();
        //TODO UI逻辑订单成功信息页面
        // checkButton.onClick.Add(() => { RedeemRecordSuccessfulDialog.OpenDialog(info); });
        SDialogManagerFC.openDialog(RedeemRecordSuccessfulDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RedeemRecordSuccessfulDialogFC),
            recordInfo: redeemRecordInfo,
            onClose: () => {
                onUpdateData?.();
            }
        })
    }

    const onCLickReviewCanCancel = () => {
        TrackRedeem.redeem_review_show();
        //TODO 弹出和审核中弹窗，弹窗里面在调用下面取消的逻辑
        //TODO UI逻辑订单取消信息页面
        TrackRedeem.redeem_review_click(2)
        SDialogManagerFC.openDialog(RedeemRecordReviewDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RedeemRecordReviewDialogFC),
            recordInfo: redeemRecordInfo,
            from: 2,
            onClose: () => {
                onUpdateData?.()
            }
        });
    }

    const onClickFail = () => {
        TrackRedeem.redeem_fail_show();
        //todo 失败的界面  直接打开一个通用的失败界面
        SDialogManagerFC.openDialog(RedeemRecordFailDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RedeemRecordFailDialogFC),
            recordInfo: redeemRecordInfo,
            onClose: () => {
                onUpdateData?.()
            }
        });
    }

    const onClickKycUrl = () => {
        const {kycUrl}= redeemRecordInfo;
        if (kycUrl){
            SDialogManagerFC.closeDialogFC(RedeemSubmittedDialogFC);
            SDialogManagerFC.openDialog(RedeemKYCDialogFC);
            window.open(kycUrl);
        }
        else{
            BigTips.showMsg('Wrong kyc URL');
        }
    }

    const updateState = () => {
        let content;
        const {state} = redeemRecordInfo;
        switch (state) {
            case RedeemRecordState.Successful:
                content = <>
                    <div style={{color: status.success}}>Successful</div>
                    <Button color="#33D24A" style={btnStyles} onClick={onCLickSuccessful}>Check</Button>
                </>
                break;
            case RedeemRecordState.ReviewCanCancel:
                content = <>
                    <div style={{color: status.reCheck}}>Under review</div>
                    <Button color="#0090FF" style={btnStyles} onClick={onCLickReviewCanCancel}>Cancel</Button>
                </>
                break;
            case RedeemRecordState.ReviewNoCancel:
                content = (<div style={{color: status.reCheck}}>Under review</div>)
                break;
            case RedeemRecordState.Process:
                content = (<div style={{color: status.reCheck}}>Processing</div>)
                break;
            case RedeemRecordState.KycOpen:
                content = <>
                    <div style={{color: status.reCheck}}>Identity Verify</div>
                    <Button color="#ff0000" style={btnStyles} onClick={onClickKycUrl}>Go</Button>
                </>
                break;
            case RedeemRecordState.KycOpenRetry:
                content = <>
                    <div style={{color: status.reCheck}}>Identity Err</div>
                    <Button color="#ff0000" style={btnStyles} onClick={onClickKycUrl}>Go Retry</Button>
                </>
                break;
            case RedeemRecordState.KycProcess:
                content = (<div style={{color: status.reCheck}}>Identity Processing</div>)
                break;
            case RedeemRecordState.KycFail:
                content = (<div style={{color: status.reCheck}}>Identity Fail</div>)
                break;

            default:
                content = <>
                    <div style={{color: status.fail}}>Fail</div>
                    <Button color={'#33D24A'} style={btnStyles} onClick={onClickFail}>Check</Button>
                </>
        }
        return content;
    }

    return (
            <section className={styles.row}>
                <section className={`${styles.col}`}>
                    <img
                        className={styles.icon_payment}
                        src={`${getYuanImgName(redeemRecordInfo.channelType)}`}
                    />
                    <span style={{
                        fontSize: '.5rem',
                        fontWeight: 'bold'
                    }}>{DriveUtil.ToDollarString(redeemRecordInfo.dollar)}</span>
                </section>
                <section className={`${styles.col}`}>
                    <div className={`text-auto`} style={{marginBottom: '.1rem',lineHeight:'0.4rem'}}>{redeemRecordInfo.account}</div>
                    <div>{redeemRecordInfo.dateTime}</div>
                </section>
                <section className={`${styles.col} ${styles.waiting}`}>
                    {updateState()}
                </section>
            </section>
    )
}

export default RedeemRecordItem;